// extracted by mini-css-extract-plugin
export default {"createBtn":"CreateBtn_createBtn__fV2-z","disabled":"CreateBtn_disabled__+h1c8"};